import BlankEvent from '@components/blank/BlankEvent';
import Column from '@components/Column';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import Loading from '@components/Loading';
import styled from '@emotion/styled';

import EventItem from './EventItem';
import useEvents from './hooks/useEvents';

function EventList() {
    const {
        events, fetchNextPage, isFetching, isBlank,
    } = useEvents();
    return (
        <Container fullWidth as='main' spacing={18}
            align='center'>
            {isBlank && (
                <BlankEvent/>
            )}
            {events?.map((event) => (
                <EventItem key={event.id}
                    event={event} />
            ))}
            {isFetching && (
                <Loading size='small' />
            )}
            <InfinityScrollTrigger trigger={fetchNextPage} />
        </Container>
    );
}

const Container = styled(Column)`
    padding: 20px;
`;

export default EventList;
